module.exports = __webpack_public_path__ + "static/media/elk.af0b108f.jpg";